import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DynamicForm, EmployeeConfig, DeleteConfig } from '../../../components';

const EmployeeProfile = ({
  photo,
  handleImgChange,
  employeeData, // Data passed from parent (NewEmployee)
  onSubmit, //handleEmployeeProfileSubmit from NewEmployee
  isLoading,
  departments,
  onCancel, //onCancel prop from parent
  control, // control object from the parent 
  errors, // <-- `errors` comes from the parent
  reset, //  `reset` as a prop
  isReadOnly, // for view page.
  deleting  // for delete page 
}) => {
console.log('employee data profile sir.',employeeData)
// Dynamically add department options to EmployeeConfig
let updatedEmployeeConfig; // Declare outside of the if-else block
if(deleting ){
  updatedEmployeeConfig=DeleteConfig;
}else{


  updatedEmployeeConfig = EmployeeConfig.map(field =>
    field.name === 'department_id'? {
      ...field,
      options: [
        { value: '', label: 'Select Department', disabled: true, hidden: true }, // Empty option
        ...departments, // Spread the departments after the empty option
      ]
    }
    : field
  );

}  
  // --- IMPORTANT: ADD THIS useEffect to log validation errors ---
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      console.error("EmployeeProfile: Validation Errors detected:", errors);
       toast.error('Please fill in all required fields.');
    }
  }, [errors]);

  // --- IMPORTANT: This function is called by react-hook-form's handleSubmit ---
  const handleFormSubmit = (dataFromForm) => {
    console.log('EmployeeProfile: handleSubmit successfully processed data:', dataFromForm);
    // This is where your actual onSubmit (handleEmployeeProfileSubmit) is called
    onSubmit(dataFromForm);
  };

  //This will call NewEmployee's handleCancel
  const handleProfileCancel = () => {if (onCancel) {onCancel(); }};
  console.log('deleting sir',deleting)
  return (
    <form onSubmit={onSubmit} className="space-y-8">
     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
         {/* Photo Upload Section */}
         <div className="flex flex-col items-center gap-2 bg-white/5 p-4 rounded-xl backdrop-blur-sm table">
          <div className="flex relative group">
            {/* Conditional class for image size is added here */}
            <img
              src={photo}
              alt="Profile"
              className={`${isReadOnly || deleting ? 'h-32 w-32 p-2 ring-4' : 'h-20 w-20 p-1 ring-2'} rounded-full object-cover ring-cyan-400 group-hover:ring-cyan-300 transition duration-300  mx-auto`} 
              />
            {!(isReadOnly || deleting) && (
              <label
                htmlFor="logo-upload"
                className="absolute bottom-0 right-0 bg-cyan-600 p-1 rounded-full shadow-lg cursor-pointer hover:bg-cyan-400 transition"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className="h-4 w-4 text-white"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6.827 6.175A2.31 2.31 0 015.18 8.077L3.465 14.887a2.122 2.122 0 00-.226 1.096v1.391a2.122 2.122 0 002.122 2.122h13.149a2.122 2.122 0 002.122-2.122v-1.391a2.122 2.122 0 00-.226-1.096L18.82 8.077a2.31 2.31 0 01-1.647-1.902V4.5a.75.75 0 00-.75-.75h-8.25a.75.75 0 00-.75.75v1.675zM12 18.5a.75.75 0 110-1.5.75.75 0 010 1.5z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 15a3 3 0 100-6 3 3 0 000 6z"
                  />
                </svg>
                <input
                  id="logo-upload"
                  type="file"
                  name="logo"
                  accept="image/*"
                  onChange={handleImgChange}
                  className="hidden"
                />
              </label>
            )}
          </div>
          {!(isReadOnly || deleting) && (
            <div>
              <p className="text-sm text-cyan-200">Upload profile photo</p>
              <p className="text-xs text-slate-300">Max size: 2MB | Format: JPG, PNG</p>
            </div>
          )}

          </div>

        {/* Manual fields controlled by react-hook-form */}
        <div className="relative space-y-4">
          <div>
            <label htmlFor="salutation" className="text-sm text-cyan-300">Salutation</label>
            {isReadOnly || deleting ? (
              // If isReadOnly is true, show the salutation as text in a paragraph or div
              <p className="text-white">{employeeData?.salutation || 'N/A'}</p>
            ) : (
            <Controller
              name="salutation"
              control={control}
              rules={{ required: 'Salutation is required' }} // <-- ADDED validation rules
           
              render={({ field }) => (
                <select
                  {...field}
                  id="salutation"
                  className={`w-full bg-gray-500 text-white border-b-2 focus:outline-none focus:border-cyan-300 ${
                    errors.salutation ? 'border-red-500' : 'border-cyan-500'
                  }`}   
                >
                  <option value="" disabled hidden>
                    Select Salutation
                  </option>
                  <option value="">Select Salutation</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Ms">Ms</option>
                  <option value="Dr">Dr</option>
                  <option value="Prof">Prof</option>
                </select>
              )}
            />
            )}
            {errors.salutation && (
            <p className="text-red-500 text-xs mt-1">{errors.salutation.message}</p>
          )}
          </div>

          <div>
            <label htmlFor="first_name" className="text-sm text-cyan-300">First Name</label>
            {isReadOnly || deleting? (
              // If isReadOnly is true, show the salutation as text in a paragraph or div
              <p className="text-white">{employeeData?.first_name || 'N/A'}</p>
            ) : (
            <Controller
              name="first_name"
              control={control}
              rules={{ required: 'First name is required' }} // <-- ADDED validation rules
           
              render={({ field }) => (
                <input
                  {...field}
                  id="first_name"
                  type="text"
                  className={`w-full bg-gray-500 text-white border-b-2 focus:outline-none focus:border-cyan-300 ${
                    errors.first_name ? 'border-red-500' : 'border-cyan-500'
                  }`}
                  placeholder="First Name"
                />
              )}
            />
          )}
            {errors.first_name && (
            <p className="text-red-500 text-xs mt-1">{errors.first_name.message}</p>
          )}
          </div>

          <div>
            <label htmlFor="last_name" className="text-sm text-cyan-300">Last Name</label>
            {isReadOnly || deleting ? (
              // If isReadOnly is true, show the salutation as text in a paragraph or div
              <p className="text-white">{employeeData?.last_name || 'N/A'}</p>
            ) : (
            <Controller
              name="last_name"
              control={control}
              rules={{ required: 'Last name is required' }} // <-- ADDED validation rules
           
              render={({ field }) => (
                <input
                  {...field}
                  id="last_name"
                  type="text"
                  className={`w-full bg-gray-500 text-white border-b-2 focus:outline-none focus:border-cyan-300 ${
                    errors.last_name ? 'border-red-500' : 'border-cyan-500'
                  }`}
                  placeholder="Last name"
                />
                
              )}
            />
          )}
            {errors.last_name && (
            <p className="text-red-500 text-xs mt-1">{errors.last_name.message}</p>
          )}
          </div>
        </div>
      </div>

      {/* The rest of the fields rendered by DynamicForm */}
      <div className="md:col-span-2">
        <DynamicForm
          fields={updatedEmployeeConfig}
          departments={departments}
          data={employeeData}
          onSubmit={handleFormSubmit}
          isLoading={isLoading}
          control={control} // Pass shared control to DynamicForm
          onCancel={handleProfileCancel} // Pass the cancel handler to DynamicForm
          errors={errors} // <-- Pass the errors object 
          isReadOnly={isReadOnly}

            
        />
      </div>
    </form>
  );
}
export default EmployeeProfile;
